import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/call-intel-new-feature-announcement.png';

const thumbHashString = 'ORiCC4IdeMqvZ22HgfAnFjc3eYeAmAc=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1.6842105263157894;
const originalWidth = 128;

const CallIntelNewFeatureAnnouncement = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CallIntelNewFeatureAnnouncement;
